import React from "react";
import PropTypes from "prop-types";
import {getTimeFromNow} from "../../../utils/dateutils";

const IncidentTableCreatedDate = ({date}) => (
  <div className="incident-create-date text-capitalize">
    {getTimeFromNow(date, true)}
  </div>
);

IncidentTableCreatedDate.propTyoes = {
  date: PropTypes.instanceOf(Date)
};

export default IncidentTableCreatedDate;
